<template lang="pug">
  .modal.is-active
    .modal-background(@click="closeModalInforme")
    .card.card-padre(:class="{'sidebar-open-card': showSidebarDesktop }")
      header.modal-card-head.display-flex
        p.flex-1
          span Informe de delegación
        span.icon.close(
            @click="$emit('close')"
          )
            i.fa.fa-close
      .card-content.position-relative
        //- .box.has-text-left.margin-right-10.margin-left-10.overflow-y-auto
        .is-desktop
          table.table.is-striped.is-bordered
            thead
              th Descripcion
              th Módulo
              th Datos
            tbody(
              name="table-row"
              is="transition-group"
            )
              tr.row-table(
                v-for="(o, index) in lista"
                :key="index"
              )
                td
                  span.hint--top.inline(:aria-label="'log: ' + o.id") {{ o.descripcion || o.accion }}&nbsp;
                  span.hint--top.has-text-bold(:aria-label="o.fechaString") {{   o.fecha | fromNow }}
                td
                  span.hint--top(:aria-label="'ID relacionado: ' + o.idRelacionado") {{ o.modulo | capitalize}}
                td
                  div
                    span.has-text-bold Accion:&nbsp;
                    span.hint--top.tipo-icon(:aria-label="o.tipo")
                      i(:class="tipoIcon[o.tipo]")
                  div(v-for="(value, key) in o.datos")
                    span.has-text-bold {{  key | capitalize }}:&nbsp;
                    span {{  value }}
        .is-mobile
          .position-relative.informe-contenedor(v-for="o in lista")
            .fecha
              span {{ o.fechaString }}
            .modulo
              span {{ o.modulo }}
            .descripcion
              span.name {{ o.descripcion }}
            .datos(v-for="(value, key) in o.datos")
              div
                span.text-small {{ key | capitalize }}:&nbsp;
                span {{ value }}
            .solicitud
              span.text-small Solicitud:&nbsp;
              span {{ o.idRelacionado }}
</template>
<script>
import { apiGet, notify } from '../util/general'
export default {
  name: 'gestion-delegaciones-informe-rrhh',
  data () {
    return {
      lista : [],
      isLoading: false,
      tipoIcon:{
        'guardar'        : 'fa fa-save',
        'enviar'          : 'fa fa-check',
        'aprobar'        : 'fa fa-check',
        'rechazar'       : 'fa fa-times',
        'desactivar'     : 'fa fa-times',
        'no lo tomo'     : 'fa fa-times',
        'notificar'      : 'fa fa-envelope',
        'editar'         : 'fa fa-edit',
        'adjuntar'       : 'fa fa-paperclip',
        'ver'            : 'fa fa-eye'
      }
    }
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  mounted () {
    this.fetchInforme(this.id)
  },
  computed: {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  methods: {
    fetchInforme (idDelegacion) {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      var obj = {
        idDelegacion: idDelegacion
      }
      apiGet(vm, '/delegaciones/informe', obj, function (data) {
        data.informe.forEach(function (o) {
          o.datos = JSON.parse(o.datos)
        })
        vm.lista = data.informe
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
        if (vm.lista.length === 0) {
          notify(vm, 'warning', 'Información', 'No se encontraron datos')
          vm.closeModalInforme()
        }
      })
    },
    closeModalInforme () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="stylus" scoped>
  .card
    header
      span
        i
          cursor: pointer
  .card-padre
    position: absolute;
    top: 55.5px;
    right: 10px;
    left: 55px;
    bottom: 10px;
    &.sidebar-open-card
      left: 200px
    .card-content
      overflow-y: auto !important;
      height: calc(100vh - 144px);

  .overflow-y-auto
    overflow-y scroll !important
    max-height: 16.9em
  .informe-contenedor
    background-color #fff
    border-radius: 5px;
    box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);
    color: #4a4a4a;
    // display: block;
    padding: 1.25rem;
    margin-bottom: 1.25rem;
    .fecha
      position absolute
      top 0px
      right 5px
      font-weight bold
      span
        color #4a4a4a
        font-size 12px
    .modulo
      position absolute
      top 0px
      left 5px
      font-weight bold
      text-transform uppercase
      span
        color #4a4a4a
        font-size 11px
    .descripcion
      color #4a4a4a
      padding-top 10px
      .name
        font-size 16px
  .is-mobile
    display none

  @media (max-width: 820px)
    .card-padre
      left: 10px
      top: 10px
      &.sidebar-open-card
        left: 10px
        top: 10px
  @media (max-width 640px)
    .is-mobile
      display block
    .is-desktop
      display none
    .card-padre
      .card-content
        height: calc(100vh - 99px)
    .name
      font-size: 16px;
</style>



// WEBPACK FOOTER //
// Component_Delegaciones_Informe.vue?219bf291